// API
export { PermissionAPI } from "./api"

// Hooks
export {
  useHasPermission,
  useHasAnyPermission,
  useHasAllPermissions,
  useUserPermissions
} from "./hooks"

// Utils
export {
  hasPermission,
  hasAnyPermission,
  hasAllPermissions,
  getUserPermissions
} from "./utils"

// Import for default export
import { PermissionAPI } from "./api"
import {
  useHasPermission,
  useHasAnyPermission,
  useHasAllPermissions,
  useUserPermissions
} from "./hooks"
import {
  hasPermission,
  hasAnyPermission,
  hasAllPermissions,
  getUserPermissions
} from "./utils"

// Default export
export default {
  PermissionAPI,
  useHasPermission,
  useHasAnyPermission,
  useHasAllPermissions,
  useUserPermissions,
  hasPermission,
  hasAnyPermission,
  hasAllPermissions,
  getUserPermissions
}